// Generisches Abrechnungs-Datenmodell (rag-admin "Abrechnung"-Tab). Aktuell nur D-ID als
// funktionierende Quelle implementiert - OpenAI/HeyGen koennen spaeter als weitere Provider
// ergaenzt werden, ohne dieses Format aendern zu muessen (siehe plan-did-billing-reconciliation.md).

export type BillingProvider = 'did' | 'openai' | 'heygen';

// "-- nicht zugeordnet --" Zeile fuer Kosten, die keinem Mandanten zugeordnet werden konnten
// (z.B. geloeschter Bot, oder Session ohne bekannten Ownership-Eintrag).
export const UNASSIGNED_ORG = "-- nicht zugeordnet --";

// Provider-uebergreifendes Ergebnis-Zeilenformat einer Abrechnungs-Konsolidierung. Eine Zeile pro
// Mandant + Provider (NICHT pro Bot) - damit die Kosten eines Mandanten direkt summiert ablesbar
// sind, ohne mehrere Bot-Zeilen manuell zusammenrechnen zu muessen. Welcher Engine-Teil (D-ID,
// OpenAI, ...) die Kosten verursacht hat, geht aus der `provider`-Spalte hervor.
export type BillingReportRow = {
    provider: BillingProvider,
    // "-- nicht zugeordnet --" fuer Kosten, die keinem Mandanten zugeordnet werden konnten.
    orgShort: string,
    // Namen der beitragenden Bots dieses Mandanten (informativ, joined), NICHT Teil der Gruppierung.
    bots: string,
    // Freier, provider-spezifischer Text (D-ID: Avatar-Produktgeneration wie "V4"/"V3 Pro").
    category: string,
    // Anzahl Antworten/Sessions/Requests, je nach Provider.
    unitCount: number,
    totalDurationSec: number,
    cost: number,
    // NIE Kosten unterschiedlicher costUnit vermischt summieren (Credits != USD).
    costUnit: 'credits' | 'usd',
    firstSeen: string,
    lastSeen: string,
}

// Eine Zeile aus D-IDs "Credits Usage"-CSV-Export (Account-Einstellungen -> Credits -> Export).
// Feinste verfuegbare Abrechnungsgranularitaet (pro einzelner Antwort/Message, nicht pro Session) -
// wird von keiner D-ID API geliefert, nur ueber diesen manuellen Export.
export type DIdBillingCsvRow = {
    created_at: string,
    product: string,
    entity_type: string,
    id: string,
    chat_id: string,
    agent_id: string,
    source: string,
    duration: number,
    credits: number,
    created_by: string,
    email: string,
    owner_id: string,
}
